import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BannerForm from "./BannerForm";
import BannerText from "./BannerText";
import { LogoSlide } from "./LogoSlide";

const TopBanner = () => {
  return (
    <Container fluid className="top-banner">
      <Row>
        <Col md="12">
          <Container>
            <Row className="py-md-5">
              <Col md="7" sm="12" xs="12">
                <BannerText />
              </Col>
              <Col md="5" sm="12" xs="12" className="d-md-flex align-items-center">
                <BannerForm />
              </Col>
            </Row>
            {/* <Row>
              <Col>
                <LogoSlide />
              </Col>
            </Row> */}
          </Container>
        </Col>
      </Row>
    </Container>
  );
};

export default TopBanner;
